import { createSlice } from "@reduxjs/toolkit";

import { adapter } from "./adapter";

const name = "achCompanies";

const slice = createSlice({
  name,
  initialState: adapter.getInitialState(),
  reducers: {
    setAll: adapter.setAll,
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
